import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteEmailMessage,
  SendEmailMessage,
  getAllEmailHistory,
  getDeleteEmailStatus,
  getSentEmailStatus,
  loadAllEmailHistory,
} from "../../../app/store/users";
import Moment from "react-moment";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import SendEmail from "./SendEmail";
import useDocDownload from "../../../app/hooks/useDocDownload";

const MailHistory = (props) => {
  const {
    showHideMailHistory,
    handleShowHideMailHistory,
    selectedObj,
    handleRefreshData,
    viewType,
  } = props;

  const [allMailHistory, setAllMailHistory] = useState([]);
  const [selectedEmail] = useState([]);
  const [sendEmailShowHide, setSendEmailShowHide] = useState(false);
  const [selectedMailObj, setSelectedMailObj] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const allEmailHistorySelector = useSelector(getAllEmailHistory);
  const sentEmailStatusSelector = useSelector(getSentEmailStatus);
  const deleteEmailStatusSelector = useSelector(getDeleteEmailStatus);
  const dispatch = useDispatch();
  const [handleDownloadFile] = useDocDownload();

  const isDraftView = viewType === "draft";
  const title = isDraftView ? "Draft Messages" : "Sent History";
  const subtitle = isDraftView
    ? "Unsent drafts for this user"
    : "Previously sent messages for this user";

  const getInitials = (obj) => {
    const parts = [obj?.performername, obj?.lastName].filter(Boolean);
    if (!parts.length) return "?";
    return parts
      .slice(0, 2)
      .map((p) => p.charAt(0).toUpperCase())
      .join("");
  };

  useEffect(() => {
    if (selectedObj?.performerid && showHideMailHistory) {
      setIsLoading(true);
      dispatch(loadAllEmailHistory(selectedObj.performerid));
    }
  }, [selectedObj, showHideMailHistory]);

  useEffect(() => {
    const list = allEmailHistorySelector || [];
    const dMails = list.filter((x) => x.sendStatus !== true);
    const sentMails = list.filter((x) => x.sendStatus === true);
    setAllMailHistory(isDraftView ? dMails : sentMails);
    setIsLoading(false);
  }, [allEmailHistorySelector, isDraftView]);

  useEffect(() => {
    if (sentEmailStatusSelector) {
      getAlert("", "Draft Mail Sent Successfully", "success");
      if (selectedObj?.performerid) dispatch(loadAllEmailHistory(selectedObj.performerid));
      if (typeof handleRefreshData === "function") handleRefreshData();
    }
  }, [sentEmailStatusSelector]);

  useEffect(() => {
    if (deleteEmailStatusSelector) {
      getAlert("", "Draft Mail Deleted Successfully", "success");
      if (selectedObj?.performerid) dispatch(loadAllEmailHistory(selectedObj.performerid));
      if (typeof handleRefreshData === "function") handleRefreshData();
    }
  }, [deleteEmailStatusSelector]);

  const handleSendEmail = async (item) => {
    const result = await getConfirmAlert(
      "Draft Email",
      "Are you sure you want to Send this Draft mail?",
      "warning"
    );
    if (result.isConfirmed) dispatch(SendEmailMessage(item.id));
  };

  const handleDeleteEmail = async (item) => {
    const result = await getConfirmAlert(
      "Draft Email",
      "Are you sure you want to Delete this Draft mail?",
      "warning"
    );
    if (result.isConfirmed) dispatch(DeleteEmailMessage(item.id));
  };

  const handleSendEmailShowHide = (item) => {
    setSendEmailShowHide(!sendEmailShowHide);
    setSelectedMailObj(item || null);
  };

  const handleUpdateModalShowHide = () => {
    setSendEmailShowHide(false);
    setSelectedMailObj(null);
    if (selectedObj?.performerid) {
      dispatch(loadAllEmailHistory(selectedObj.performerid));
    }
  };

  const handleClose = () => handleShowHideMailHistory(null, "");

  const colCount = isDraftView ? 7 : 6;

  return (
    <>
      <Modal
        show={showHideMailHistory}
        size="xl"
        centered
        onHide={handleClose}
        dialogClassName="mh-modal-dialog"
      >
        <style>{`
          .mh-modal-dialog .modal-content {
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            overflow: hidden !important;
            box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
            background: #ffffff !important;
          }
          .mh-wrap {
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          }
          .mh-header {
            display: flex;
            align-items: center;
            gap: 14px;
            padding: 16px 22px;
            background: #f8fafc;
            border-bottom: 1px solid #e5e5e5;
          }
          .mh-header-icon {
            width: 42px; height: 42px; border-radius: 0;
            background: #f5f5f5; border: 1px solid #d4d4d4;
            display: flex; align-items: center; justify-content: center;
            font-size: 17px; color: #171717; flex-shrink: 0;
          }
          .mh-header-title {
            color: #171717; font-size: 14.5px; font-weight: 700; margin: 0; line-height: 1.2;
          }
          .mh-header-sub {
            color: #737373; font-size: 12px; margin: 3px 0 0; font-weight: 400;
          }
          .mh-header-badge {
            margin-left: auto;
            background: #f5f5f5; border: 1px solid #d4d4d4;
            border-radius: 0; padding: 4px 12px;
            color: #171717; font-size: 11.5px; font-weight: 600;
            display: inline-flex; align-items: center; gap: 6px;
          }
          .mh-close {
            margin-left: 10px;
            width: 34px; height: 34px;
            border: 1px solid #d4d4d4; border-radius: 0;
            background: #ffffff; color: #525252;
            display: inline-flex; align-items: center; justify-content: center;
            cursor: pointer; transition: all 0.2s ease;
          }
          .mh-close:hover {
            background: #f5f5f5; color: #171717; border-color: #a3a3a3;
          }
          .mh-body {
            padding: 16px 22px 22px;
            background: #f8fafc;
          }
          

          .mh-wrap .wf-table {
            width: 100% !important;
            border-collapse: separate !important;
            border-spacing: 0 2px !important;
            margin: 0 !important;
          }
          .mh-wrap .wf-table-scroll {
            overflow: auto !important;
            max-height: 420px;
            scrollbar-width: thin;
            scrollbar-color: #94a3b8 #f1f5f9;
            border-radius: 0;
            border: 1px solid #cbd5e1 !important;
            background: #ffffff;
          }
          .mh-wrap .wf-table-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
          .mh-wrap .wf-table-scroll::-webkit-scrollbar-track {
            background: #f1f5f9; border-radius: 0;
          }
          .mh-wrap .wf-table-scroll::-webkit-scrollbar-thumb {
            background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
            border-radius: 0; border: 2px solid #f1f5f9;
          }
          .mh-wrap .wf-thead {
            background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
            position: sticky !important; top: 0 !important; z-index: 2 !important;
          }
          .mh-wrap .wf-thead th {
            font-size: 11.5px !important; font-weight: 600 !important; color: #475569 !important;
            text-transform: uppercase !important; letter-spacing: 0.6px !important;
            padding: 13px 16px !important; border-bottom: 2px solid #e2e8f0 !important;
            border-top: none !important; white-space: nowrap !important;
          }
          .mh-wrap .wf-table-row {
            cursor: pointer !important;
            transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
          }
          .mh-wrap .wf-table-row:hover {
            background: #f8fafc !important;
            box-shadow: inset 3px 0 0 0 #171717 !important;
          }
          .mh-wrap .wf-table-row:hover td { color: #000000 !important; }
          .mh-wrap .wf-table-row:active {
            transform: scaleY(0.98) !important;
          }
          .mh-wrap .wf-table td {
            padding: 13px 16px !important; font-size: 13px !important; color: #000000 !important;
            border-bottom: 1px solid #f1f5f9 !important; vertical-align: middle !important;
            background: transparent !important;
          }
          .mh-wrap .wf-table tbody tr:last-child td { border-bottom: none !important; }
          .mh-wrap .wf-id-cell {
            display: inline-flex; align-items: center; gap: 6px;
            min-width: 52px; padding: 4px 8px; border-radius: 0;
            background: #f8fafc; border: 1px solid #e2e8f0;
            font-size: 12px; font-weight: 600; color: #64748b;
          }
          .mh-wrap .wf-empty-value { color: #cbd5e1; font-size: 12px; font-weight: 600; }
          .mh-wrap .badge-capsule {
            display: inline-flex !important; align-items: center !important; justify-content: center !important;
            padding: 4px 10px !important; border-radius: 0 !important;
            font-size: 12px !important; font-weight: 600 !important; line-height: 1 !important;
          }
          .mh-wrap .badge-sent {
            background: rgba(16,185,129,0.08) !important; color: #047857 !important;
            border: 1px solid rgba(16,185,129,0.15) !important;
          }
          .mh-wrap .badge-draft {
            background: #f5f5f5 !important; color: #525252 !important;
            border: 1px solid #d4d4d4 !important;
          }
          .mh-wrap .btn-action-search {
            display: inline-flex !important; align-items: center !important; justify-content: center !important;
            gap: 6px !important; background: #ffffff !important; border: 1px solid #d4d4d4 !important;
            padding: 6px 12px !important; border-radius: 0 !important;
            font-size: 12px !important; font-weight: 400 !important; color: #404040 !important;
            cursor: pointer !important; transition: all 0.2s !important; box-shadow: none !important;
          }
          .mh-wrap .btn-action-search:hover {
            background: #f5f5f5 !important; border-color: #a3a3a3 !important; color: #171717 !important;
          }
          .mh-wrap .btn-action-search.btn-primary-search {
            background: #2563eb !important;
            color: #ffffff !important;
            border-color: #2563eb !important;
          }
          .mh-wrap .btn-action-search.btn-primary-search:hover {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
          }
          .mh-wrap .btn-action-search.btn-danger-search {
            background: rgba(239,68,68,0.06) !important; color: #dc2626 !important;
            border: 1px solid rgba(239,68,68,0.18) !important;
          }
          .mh-wrap .btn-action-search.btn-danger-search:hover {
            background: rgba(239,68,68,0.12) !important; color: #b91c1c !important;
          }
          .mh-wrap .wf-empty-state {
            display: flex; flex-direction: column; align-items: center; justify-content: center;
            padding: 48px 24px; text-align: center; gap: 12px;
          }
          .mh-wrap .wf-empty-icon {
            width: 52px; height: 52px; border-radius: 0;
            display: flex; align-items: center; justify-content: center; font-size: 22px;
            background: #171717; border: 1px solid #171717; color: #ffffff; margin-bottom: 4px;
          }
          .mh-wrap .wf-empty-title { font-size: 15px; font-weight: 600; color: #171717; margin: 0; }
          .mh-wrap .wf-empty-desc { font-size: 13px; color: #525252; margin: 0 auto; line-height: 1.6; max-width: 360px; }
          .mh-wrap .skeleton-cell {
            display: block; height: 13px; border-radius: 0;
            background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
            background-size: 600px 100%;
            animation: mhShimmer 1.4s ease-in-out infinite;
          }
          .mh-wrap .skeleton-cell.sk-short { width: 40%; }
          .mh-wrap .skeleton-cell.sk-medium { width: 65%; }
          .mh-wrap .skeleton-cell.sk-long { width: 85%; }
          @keyframes mhShimmer {
            0% { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }
          .mh-body-clamp {
            max-height: 44px; overflow: hidden; text-overflow: ellipsis;
            display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
            font-size: 12.5px; line-height: 1.4; color: #525252;
          }
        `}</style>

        <div className="mh-wrap">
          <div className="mh-header">
            <div className="mh-header-icon">
              <i className={`fa ${isDraftView ? "fa-pencil-square-o" : "fa-paper-plane"}`} />
            </div>
            <div>
              <p className="mh-header-title">{title}</p>
              <p className="mh-header-sub">{subtitle}</p>
            </div>
            <span className="mh-header-badge">
              <i className="fa fa-envelope-o" />
              {allMailHistory.length} {isDraftView ? "Drafts" : "Sent"}
            </span>
            <button type="button" className="mh-close" onClick={handleClose} title="Close">
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="mh-body">
            <div className="mh-assign-card">
              <div className="mh-assign-avatar">{getInitials(selectedObj)}</div>
              <div className="mh-assign-meta">
                <strong>
                  {selectedObj?.performername} {selectedObj?.lastName}
                </strong>
                <span>{selectedObj?.performeremail || "No email"}</span>
              </div>
            </div>

            <div className="table-responsive wf-table-scroll">
              <table className="table align-items-center table-flush wf-table">
                <thead className="wf-thead">
                  <tr>
                    <th>S.No.</th>
                    <th>{isDraftView ? "Created" : "Sent"}</th>
                    <th>Subject</th>
                    <th>Body</th>
                    <th>Attachments</th>
                    <th>Status</th>
                    {isDraftView && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    Array.from({ length: 4 }).map((_, i) => (
                      <tr key={`skel-${i}`} className="skeleton-row">
                        {Array.from({ length: colCount }).map((_, j) => (
                          <td key={j}>
                            <span
                              className={`skeleton-cell ${j % 2 === 0 ? "sk-short" : "sk-medium"}`}
                              style={{ animationDelay: `${i * 0.05}s` }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : allMailHistory.length === 0 ? (
                    <tr>
                      <td colSpan={colCount} style={{ padding: 0 }}>
                        <div className="wf-empty-state">
                          <div className="wf-empty-icon">
                            <i className={`fa ${isDraftView ? "fa-pencil-square-o" : "fa-paper-plane-o"}`} />
                          </div>
                          <p className="wf-empty-title">
                            {isDraftView ? "No Draft Messages" : "No Sent Messages"}
                          </p>
                          <p className="wf-empty-desc">
                            {isDraftView
                              ? `There are no saved drafts for ${selectedObj?.performername || "this user"}.`
                              : `No messages have been sent to ${selectedObj?.performername || "this user"} yet.`}
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    allMailHistory.map((item, idx) => (
                      <tr key={item.id || idx} className="wf-table-row">
                        <td>
                          <span className="wf-id-cell">#{idx + 1}</span>
                        </td>
                        <td>
                          {(isDraftView ? item.addedDateTime : item.sendDateTime || item.addedDateTime) ? (
                            <Moment format="MMM Do YYYY, h:mm a">
                              {isDraftView
                                ? item.addedDateTime
                                : item.sendDateTime || item.addedDateTime}
                            </Moment>
                          ) : (
                            <span className="wf-empty-value">—</span>
                          )}
                        </td>
                        <td>
                          <span
                            className="text-truncate d-block"
                            style={{ maxWidth: 220, fontWeight: 600 }}
                            title={item.subject}
                          >
                            {item.subject || <span className="wf-empty-value">No Subject</span>}
                          </span>
                        </td>
                        <td>
                          <div className="mh-body-clamp" title={item.mailBody}>
                            {item.mailBody || <span className="wf-empty-value">Empty message</span>}
                          </div>
                        </td>
                        <td>
                          {item?.documents?.length > 0 ? (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                              {item.documents.map((file, fIdx) => (
                                <button
                                  key={fIdx}
                                  type="button"
                                  className="btn-action-search"
                                  title="Download Attachment"
                                  onClick={() => handleDownloadFile(file)}
                                >
                                  <i className="fa fa-paperclip" style={{ fontSize: 11 }} />
                                  <span className="text-truncate" style={{ maxWidth: 100 }}>
                                    {file.documentName}
                                  </span>
                                </button>
                              ))}
                            </div>
                          ) : (
                            <span className="wf-empty-value">None</span>
                          )}
                        </td>
                        <td>
                          {item.sendStatus ? (
                            <span className="badge-capsule badge-sent">Sent</span>
                          ) : (
                            <span className="badge-capsule badge-draft">Draft</span>
                          )}
                        </td>
                        {isDraftView && (
                          <td onClick={(e) => e.stopPropagation()}>
                            {!item.sendStatus && (
                              <div style={{ display: "inline-flex", gap: 6, flexWrap: "wrap" }}>
                                <button
                                  type="button"
                                  className="btn-action-search btn-primary-search"
                                  onClick={() => handleSendEmail(item)}
                                  title="Send Draft"
                                >
                                  Send
                                </button>
                                <button
                                  type="button"
                                  className="btn-action-search"
                                  onClick={() => handleSendEmailShowHide(item)}
                                  title="Edit Draft"
                                >
                                  Edit
                                </button>
                                <button
                                  type="button"
                                  className="btn-action-search btn-danger-search"
                                  onClick={() => handleDeleteEmail(item)}
                                  title="Delete Draft"
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>

      {sendEmailShowHide && (
        <SendEmail
          showHide={sendEmailShowHide}
          handleModalShowHide={handleSendEmailShowHide}
          handleUpdateModalShowHide={handleUpdateModalShowHide}
          selectedObj={selectedObj}
          selectedEmail={selectedEmail}
          selectedMailObj={selectedMailObj}
          viewType="edit"
        />
      )}
    </>
  );
};

export default MailHistory;
